import { getLinkGroupById } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetLinkGroupByIdQuery = (linkGroupId, enabled = true) =>
    useQuery({
        queryKey: ['link_group', linkGroupId],
        queryFn: async () => getLinkGroupById(linkGroupId),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled,
    });
export default useGetLinkGroupByIdQuery;
